/*@ngInject*/
const FormDropdownHandleFocusDirective = function (formViewerConstant) {
        return {
            require: 'uiSelect',
            link: function ($scope, $element, $attr, $select) {
                var searchInput = $element.querySelectorAll('input.ui-select-search'),
                    currentItem;

                var handleFocusser = function () {
                    var handleFocusMethodName = $attr.dropdownHandleFocus;
                    if (_.isEmpty(handleFocusMethodName)) {
                        handleFocusMethodName = 'handleFocus';
                    }
                    if ($scope.$ctrl && _.isFunction($scope.$ctrl[handleFocusMethodName])) {
                        $scope.$ctrl[handleFocusMethodName]($select);
                    }
                };

            $select.focusser.on('focus.formViewer', handleFocusser);
            searchInput.on('focus.handleFocusDirective.dropdown', handleFocusser);

            $scope.$on('$destroy', function () {
                searchInput.off('focus.handleFocusDirective.dropdown', handleFocusser);
                $select.focusser.off('focus.formViewer', handleFocusser);
            });
        }
    };
};

angular.module('umCore')
    .directive('dropdownHandleFocus', FormDropdownHandleFocusDirective);
